import officeApi from './officeApi';

export const fetchToken = async (attempts = 1) => {
  let token;

  try {
    token = localStorage.getItem('azureToken');
    token = JSON.parse(token || '{}');
    if (token?.accessToken?.length && new Date(token.expiration).getTime() > Date.now()) {
      return token?.accessToken;
    }
  } catch (e) {
    console.error('Error fetching token from local storage ', e);
  }

  try {
    token = await new Promise((resolve, reject) => officeApi.getUserIdToken(resolve, (err) => {
      console.error('Error fetching token ', err);
      reject(err);
    }));
  } catch (e) {
    if (e.code === 12007 && attempts < 11) {
      // There is already an active add-in dialog; retry with backoff
      await new Promise((resolve) => setTimeout(resolve, 1000 * attempts));
      return await fetchToken(attempts + 1);
    }
  }

  localStorage.setItem('azureToken', JSON.stringify(token));
  return token?.accessToken;
};
